import { Injectable } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { AuthState as BaseAuthState, AuthStateModel, RefreshJWT, TokenResponse } from '@bo/ng-auth';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetTokens } from './auth.actions';

@State<AuthStateModel>({
  name: 'auth',
})
@Injectable()
export class AuthState extends BaseAuthState {
  override ngxsOnInit() {
    // Override parent to prevent clearing expired tokens on init.
    // Parent behaviour: Clears state if the access token is expired.
    // Our behaviour: Keep expired tokens and let interceptor refresh them.
    //
    // Why: Prevents race condition where guard redirects to log in before
    // interceptor can attempt token refresh (which would succeed).
  }

  @Selector()
  static refresh(state: AuthStateModel) {
    return state.refresh;
  }

  @Action(RefreshJWT)
  override refresh({ getState, patchState }: StateContext<AuthStateModel>) {
    const state: AuthStateModel = getState();
    return this.apiService.refreshToken(<string>state.refresh).pipe(
      tap((data: TokenResponse) => {
        patchState({
          token: data.access,
          refresh: data.refresh ? data.refresh : state.refresh,
        });
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  @Action(SetTokens)
  setTokens({ patchState }: StateContext<AuthStateModel>, action: SetTokens) {
    patchState({
      token: action.token.access,
      refresh: action.token.refresh,
    });
  }
}
